import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
  ValidateNested,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface PushContentListResponse {
  total: number;
  page: number;
  page_size: number;
  list: PushContent[];
};

export interface PushContent {
  cover_image_url: string;
  user_id: number;
  id: number;
  user_name: string;
  title?: string;
  type: number;
  source: string;
  push_time: number;
  read_time: number;
  status: number;
  ai_chat_record?: {
    usage: {
      prompt_tokens: number;
      completion_tokens: number;
      total_tokens: number;
    };
    model: string;
    conversation_id: string;
    task_id: string;
  };
};
// 请求接口
interface PushContentListRequest {
  type: number,
  page: number,
  agentId: string,
  pageSize: number
  source: number,
  searchType: string,
  searchValue: string,
  pushState: number,
  startTime: string,
  endTime: string,
}

export class AiChatRecordUsageData {
  @IsNumber("promptTokens must be a number")
  promptTokens: number;

  @IsNumber("completionTokens must be a number")
  completionTokens: number;

  @IsNumber("totalTokens must be a number")
  totalTokens: number;
}

export class AiChatRecordData {
  @ValidateNested(AiChatRecordUsageData)
  usage: AiChatRecordUsageData;

  @IsString("model must be a string")
  model: string;

  @IsString("conversationId must be a string")
  conversationId: string;

  @IsString("taskId must be a string")
  taskId: string;
}

export class PushContentData {
  @Required("ID cannot be empty")
  @IsNumber("ID must be a number")
  id: number;

  @Required("Cover image URL cannot be empty")
  @IsString("Cover image URL must be a string")
  coverImageUrl: string;

  @Required("User ID cannot be empty")
  @IsNumber("User ID must be a number")
  userId: number;

  @Required("User name cannot be empty")
  @IsString("User name must be a string")
  userName: string;

  @Required("Title cannot be empty")
  @IsString("Title must be a string")
  title: string;

  @Required("Type cannot be empty")
  @IsNumber("Type must be a number")
  type: number;

  @IsString("Create source must be a string")
  createSource: string;

  @Required("Source cannot be empty")
  @IsString("Source must be a string")
  source: string;

  @Required("Push time cannot be empty")
  @IsNumber("Push time must be a number")
  pushTime: number;

  @Required("Read time cannot be empty")
  @IsNumber("Read time must be a number")
  readTime: number;

  @Required("Status cannot be empty")
  @IsNumber("Status must be a number")
  status: number;

  @Required("Content cannot be empty")
  @IsString("Content must be a string")
  content: string;

  @IsNumber("Created at must be a number")
  createdAt: number;

  @ValidateNested(AiChatRecordData)
  aiChatRecord?: AiChatRecordData;
}

export class PushContentListData {
  @IsArray("List must be an array")
  list: PushContentData[];

  @Required("Total cannot be empty")
  @IsNumber("Total must be a number")
  total: number;

  @Required("Page cannot be empty")
  @IsNumber("Page must be a number")
  page: number;

  @Required("Page size cannot be empty")
  @IsNumber("Page size must be a number")
  pageSize: number;
}

const transformAndValidateAgent = (
  response: PushContentListResponse
): PushContentListData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, PushContentListData);
  } catch (error) {
    console.error("Push content list data validation failed:", error.message);
    throw error;
  }
};

/** 内容列表 */
export const pushContentList = async ({
  type,
  page,
  pageSize,
  searchType,
  searchValue,
  pushState,
  agentId,
  source,
  startTime,
  endTime,
}: PushContentListRequest): Promise<PushContentListData> => {
  const response = await api.post<PushContentListResponse>('/agent-v2/push-content-list', {
    page,
    type,
    page_size: pageSize,
    search_type: searchType,
    search_value: searchValue,
    push_state: pushState,
    source: source,
    agent_id: agentId,
    start_time: startTime,
    end_time: endTime,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
